/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FxIdDomainEntitiesAghanimPaymentStatus {
    Created = 0,
    Payed = 1,
    Cancelled = 2,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfFxIdDomainEntitiesAghanimPaymentStatus(value: any): boolean {
    for (const key in FxIdDomainEntitiesAghanimPaymentStatus) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainEntitiesAghanimPaymentStatus, key)) {
            if (FxIdDomainEntitiesAghanimPaymentStatus[key as keyof typeof FxIdDomainEntitiesAghanimPaymentStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FxIdDomainEntitiesAghanimPaymentStatusFromJSON(json: any): FxIdDomainEntitiesAghanimPaymentStatus {
    return FxIdDomainEntitiesAghanimPaymentStatusFromJSONTyped(json, false);
}

export function FxIdDomainEntitiesAghanimPaymentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainEntitiesAghanimPaymentStatus {
    return json as FxIdDomainEntitiesAghanimPaymentStatus;
}

export function FxIdDomainEntitiesAghanimPaymentStatusToJSON(value?: FxIdDomainEntitiesAghanimPaymentStatus | null): any {
    return value as any;
}

export function FxIdDomainEntitiesAghanimPaymentStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): FxIdDomainEntitiesAghanimPaymentStatus {
    return value as FxIdDomainEntitiesAghanimPaymentStatus;
}

